var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconOutlineBoltBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "r2mv9u24ga",
    d: "M3.228 13.369l-.067.09c-.424.65.036 1.543.84 1.543h6v6c0 .94 1.18 1.36 1.775.633l9-11 .067-.09c.424-.65-.036-1.543-.841-1.543h-6v-6c0-.94-1.179-1.36-1.774-.633l-9 11zm8.774-7.567v4.2l.007.117c.057.497.48.883.993.883h4.889L12 18.2v-4.198l-.006-.117c-.058-.497-.48-.883-.993-.883H6.11l5.89-7.2z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "#37c0ca",
    fillRule: "nonzero",
    xlinkHref: "#r2mv9u24ga"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOutlineBoltBlue);
export default __webpack_public_path__ + "static/media/icon-outline-bolt-blue.34c28dad9e3d7e2e2c9b2d286fa90cb6.svg";
export { ForwardRef as ReactComponent };